import { render, staticRenderFns } from "./MemoryTable.vue?vue&type=template&id=3816551b&scoped=true&lang=pug&"
import script from "./MemoryTable.vue?vue&type=script&lang=js&"
export * from "./MemoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MemoryTable.vue?vue&type=style&index=0&id=3816551b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816551b",
  null
  
)

export default component.exports